import { render, staticRenderFns } from "./Asignaciones_seedee_v8.vue?vue&type=template&id=047d35ac&scoped=true"
import script from "./Asignaciones_seedee_v8.vue?vue&type=script&lang=js"
export * from "./Asignaciones_seedee_v8.vue?vue&type=script&lang=js"
import style0 from "./Asignaciones_seedee_v8.vue?vue&type=style&index=0&id=047d35ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d35ac",
  null
  
)

export default component.exports